import { User, UserBasic } from "../models";

export function getUserFullName(user: User | undefined): string {
    if (!user) return "";
    return `${user.firstName} ${user.lastName}`;
}

export function getUserBasicFullName(user: UserBasic | undefined): string {
    if (!user) return "";
    return `${user.firstName} ${user.lastName}`;
}
